const SWITCH_AND_GAUGE_SHOW_PART_NUMBERS = 'switch_and_gauge_show_part_numbers'
const DASHBOARD_TABLES_ORDER = 'dashboard_tables_order'
const BUILDER_DRAWER_EXTENDED_WIDTH = 'builder_drawer_extended_width'
const USER_DEFAULT_LOCATION = 'user_default_location'
const ENABLE_CHEC_PLUS_MODULE_SUMMARY_EXPANDED_VIEW =
  'chec_plus_module_summary_expanded_view'

const USER_SETTINGS = {
  SWITCH_AND_GAUGE_SHOW_PART_NUMBERS,
  DASHBOARD_TABLES_ORDER,
  BUILDER_DRAWER_EXTENDED_WIDTH,
  USER_DEFAULT_LOCATION,
  ENABLE_CHEC_PLUS_MODULE_SUMMARY_EXPANDED_VIEW,
}

export default USER_SETTINGS
